var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InvocationsList',{attrs:{"header-message":"Workflow invocations that are still being scheduled are displayed on this page.","no-invocations-message":"There are no scheduling workflow invocations to show currently.","owner-grid":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }